import React, { useEffect, useRef, useState } from "react";
import { Grid, Button, FormControl, Typography, Box } from "@mui/material";
import Layout from "../../../layout/Layout";
import {
  config,
  purchaseOrderAPI,
  purchaseOrderItemsAPI,
  projectMasterAPI,
  statusMasterAPI,
} from "../../../config";
import Pdf from "react-to-pdf";
import { TextField } from "@mui/material"; // ✅ Import MUI TextField
import axios from "axios";
import NotFound from "../../../components/NotFount";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useParams, useNavigate } from "react-router-dom";
import { materialReceiptAPI } from "../../../config";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";
// import numberToWords from "number-to-words";
import moment from "moment";
import "moment/locale/en-in";
import { ToWords } from "to-words";
import { useReactToPrint } from "react-to-print";
import PoPdf from "./pdf/PoPdf";
import PurchaseOrderPDF from "./pdf/GeneratePdf";
import { PDFDownloadLink } from "@react-pdf/renderer";
import DOMPurify from "dompurify";
import PdfDocument from "./pdf/ProformaGeneratePdf";

const toWords = new ToWords({
  localeCode: "en-IN",
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: false,
    currencyOptions: {
      // can be used to override defaults for the selected locale
      name: "Rupee",
      plural: "Rupees",
      symbol: "₹",
      fractionalUnit: {
        name: "Paisa",
        plural: "Paise",
        symbol: "",
      },
    },
  },
});

const handleNumberToWOrdCurrency = (v) => {
  return toWords.convert(roundUpToInteger(v));
};

function roundUpToInteger(value) {
  const roundedValue = Math.ceil(value);
  const formattedValue = roundedValue.toFixed(2);
  return formattedValue;
}

function PurchaseOrderView() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [poDetails, setPODetails] = useState([]);
  const [paymentList, setPaymentList] = useState("");
  const [address, setAddress] = useState("");

  const [ClassificationData, setClassificationData] = useState("");
  let tempRef = useRef(false);

  // other all details (Unified Proforma details and items fetch)
  const userData = JSON.parse(localStorage.getItem("user") || "{}");
  useEffect(() => {
    if (!id) return;
    axios({
      method: "POST",
      url: materialReceiptAPI,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userData.token,
      },
      data: {
        intType: 2,
        proformaId: id,
      },
    })
      .then((res) => {
        if (res.data.success && res.data.result.length > 0) {
          const details = res.data.result[0];
          
          // Map proforma details to PO details format for compatibility
          const mappedDetails = {
            ...details,
            po_no: details.proforma_no,
            po_date: details.proforma_date,
            purchase_classfication: details.purchase_classify,
            site_engineer: details.site_eng_id,
            site_eng_contact: details.site_eng_contact,
            po_validate_upto: details.valid_to,
            delivery_scpoe: details.delivery_scope,
            terms_heading: details.terms_heading,
            terms: details.terms,
            total_amount_without_gst: details.total_without_gst,
            total_igst: details.total_igst,
            total_sgst: details.total_sgst,
            total_cgst: details.total_cgst,
            total_amount_with_gst: details.total_with_gst,
            transport_amount: details.transport_amount,
            transport_gst: details.transport_gst,
            transport_charge: details.transport_charge,
            company_Name: details.company_Name || details.company_name,
            account_no: details.account_number
          };
          setPODetails(mappedDetails);

          // Map items to PO items format for compatibility
          const mappedItems = (res.data.result[1] || []).map(item => ({
            ...item,
            units: item.unit,
            amount: item.rate,
            discount_value: item.discount,
            discount_type: "percentage",
            gst: item.gst_percentage,
            total_amount: item.total,
            total_amount_without_gst: parseFloat(item.total || 0) - (parseFloat(item.cgst || 0) + parseFloat(item.sgst || 0) + parseFloat(item.igst || 0))
          }));
          setPaymentList(mappedItems);

          const addr = details.address ? JSON.parse(details.address) : "";
          setAddress(addr);

          fetchProjectDetails(details.project_id);
          get_purchase_classification(details.purchase_classify);
        }
      })
      .catch((err) => {
        console.error("Failed to load Material Receipt details:", err);
      });
  }, [id]);
  const [projectDetails, setProjectDetails] = useState([]);

  const get_purchase_classification = (statusId) => {
    const data = {
      intType: 11,
      intStatusId: statusId,
    };

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = statusMasterAPI;

    axios(config)
      .then(function (response) {
        const result = response.data?.result;

        if (Array.isArray(result) && result.length > 0 && result[0]?.name) {
          setClassificationData(result[0].name);
        } else {
          setClassificationData("—");
          console.warn("Classification name not found in response:", result);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetchProjectDetails = (projectID) => {
    if (projectID === 0) {
      return;
    }

    const data = {
      intType: 2,
      intProjectID: projectID,
      intLimit: 1,
    };

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = projectMasterAPI;

    axios(config)
      .then((response) => {
        setProjectDetails(response.data.result[0]);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const ref = React.createRef();
  const setPOStatus = (status) => {
    const data = {
      intType: 2,
      intStatus: status,
      intPOId: id,
    };
    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = purchaseOrderAPI;

    axios(config)
      .then(function (response) {})
      .catch(function (error) {
        console.log(error);
      });
    return () => {
      tempRef.current = true;
    };
  };

  const twoDecimal = (x) => {
    // Convert to a float and format to two decimal places
    const num = Number.parseFloat(x).toFixed(2);

    // Split the integer and decimal parts
    const [integerPart, decimalPart] = num.split(".");

    // Format the integer part with a proper regex for Indian numbering system
    const formattedInteger = integerPart.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");

    // Return the formatted value with the decimal part
    return `${formattedInteger}.${decimalPart}`;
  };

  function roundUpToInteger(value) {
    const roundedValue = Math.ceil(value);
    const num = roundedValue.toFixed(2);
    // Split the integer and decimal parts
    const [integerPart, decimalPart] = num.split(".");

    // Format the integer part with a proper regex for Indian numbering system
    const formattedInteger = integerPart.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");

    // Return the formatted value with the decimal part
    return `${formattedInteger}.${decimalPart}`;
  }

  function calculateRoundingDifference(value) {
    const roundedValue = Math.ceil(value);
    const difference = roundedValue - value;

    return difference.toFixed(2);
  }

  const renderHTML = (htmlString) => {
    return { __html: DOMPurify.sanitize(htmlString) };
  };

  const styles = {
    container: {
      display: "flex",
      // flexWrap: "wrap",
      gap: "20px",
      padding: "20px",
      justifyContent: "space-between", // Distribute space between items
    },
    section: {
      flex: "1 1 calc(100% - 20px)", // Full width on small screens
      padding: "15px",
      // border: "1px solid #ddd",
      borderRadius: "5px",
      // backgroundColor: "#f9f9f9",
      // minWidth: "300px", // Minimum width of each section
    },
    bold: {
      fontWeight: "bold",
      marginTop: "6px",
    },
    companyName: {
      fontSize: "0.9 rem",
      fontWeight: "bold",
      color: "#0047AB",
    },
  };

  const logoMap = {
    "KG BUILD TECH": require("./../../../assets/images/Logo/Kg_Logo.png"),
    "KG FURN TECH": require("./../../../assets/images/Logo/Kg_furn_logo.png"),
    "KG CONSTRUCTIONS": require("./../../../assets/images/Logo/kg_const_logo.png"),
    "KG TRADE TECH": require("./../../../assets/images/Logo/kg_trade_logo.png"),
  };

  // Fetch the appropriate logo based on the company name
  const companyLogo = logoMap[poDetails.company_Name] || null; // Use null as a fallback if no match is found

  const poNo = poDetails?.po_no || ""; // fallback to empty string if undefined
  const match = poNo.match(/T(\d+)\//);
  const extractedNumber = match ? match[1] : "";
  return (
    <Layout>
      <Grid className="employee-form">
        <Grid item xs={12} lg={12} md={12}>
          <Grid container spacing={3} sx={{ alignItems: "center", mb: "20px" }}>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <Typography className="page_title" textAlign="left">
                Material Receipt View
              </Typography>
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/dashboard">
                  Dashboard
                </Link>
                <Typography color="text.primary">Material Receipt</Typography>
                <Typography color="text.primary">View</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid
              item
              className="form-lable"
              xs={12}
              lg={6}
              md={6}
              style={{ textAlign: "right" }}
            >
              <LoadingButton
                size="medium"
                variant="contained"
                color="primary"
                onClick={() => navigate(-1)}
                startIcon={<ArrowBackIosIcon />}
                className="button_first"
              >
                Back
              </LoadingButton>
            </Grid>
          </Grid>
          <Grid container spacing={2} className={`bg-white`}>
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              style={{ height: "100%" }}
              ref={ref}
              className="container print-container"
            >
              <div className="print-content">
                <Grid className="element-to-po">
                  <Grid className="page">
                    <Typography
                      textAlign=""
                      className={``}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <h1 style={{ color: "#0066cc" }}>
                        {poDetails.order_type == "1"
                          ? "Purchase Order"
                          : "Work Order"}
                      </h1>
                    </Typography>
                    <table className="tablepad">
                      <tr className="no-border">
                        <td colSpan={4}>
                          <tr className="no-border">
                            <td colSpan={4} style={{ textAlign: "right" }}>
                              <Typography
                                className="td text-bold"
                                style={{ fontSize: "15px" }}
                              >
                                {extractedNumber} {poDetails.vendor_name}{" "}
                                {moment(poDetails.po_date).format("DD-MM-YYYY")}{" "}
                                @ {poDetails.project_name}
                              </Typography>
                            </td>
                          </tr>

                          <hr />

                          <tr className="no-border">
                            <td className="no-border imgtd">
                              <img
                                src={companyLogo}
                                alt="KG"
                                width={`200px`}
                                height={`auto`}
                              />
                            </td>
                            <td width={`100%`} className="no-border">
                              <table>
                                <tr>
                                  <td className="no-border">
                                    <Typography
                                      textAlign="right"
                                      // className="td text-bold"
                                      sx={{
                                        fontSize: "23px",
                                        fontWeight: 700,
                                        color: "#0066cc",
                                      }}
                                    >
                                      {poDetails.company_Name}
                                    </Typography>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="no-border">
                                    <Typography
                                      textAlign="right"
                                      // className={`td text-bold`}
                                      sx={{
                                        fontSize: "15px",
                                      }}
                                    >
                                      {poDetails
                                        ? poDetails.company_address
                                        : `Plot No 108, Perumal Koil Street, Alapakkam
                                Porur`}
                                    </Typography>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="no-border">
                                    <Typography
                                      textAlign="right"
                                      // className={`td text-bold`}
                                      sx={{
                                        fontSize: "15px",
                                      }}
                                    >
                                      {poDetails
                                        ? `${poDetails.company_city} - ${poDetails.company_pincode}`
                                        : `Chennai - 600116`}
                                    </Typography>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="no-border">
                                    <Typography
                                      textAlign="right"
                                      // className={`td text-bold`}
                                      sx={{
                                        fontSize: "15px",
                                      }}
                                    >
                                      {poDetails
                                        ? `${poDetails.company_state}, India`
                                        : `Tamil Nadu, India`}
                                    </Typography>
                                  </td>
                                </tr>
                                <tr>
                                  {/* <td className="no-border">
                                <Typography
                                  textAlign="right"
                                  className={`td text-bold`}
                                >
                                  {poDetails
                                    ? `${poDetails.company_primary_contact} / ${poDetails.company_secondary_contact}`
                                    : `044 2476 5544 / +91 95001 55544`}
                                </Typography>
                              </td> */}
                                </tr>
                                {/* <tr>
                              <td className="no-border">
                                <Typography
                                  textAlign="right"
                                  // className={`td text-bold`}
                                  sx={{
                                    fontSize: "15px",
                                  }}
                                >
                                  {poDetails
                                    ? poDetails.company_emailId
                                    : `venkat@kgbuildtech.com`}
                                </Typography>
                              </td>
                            </tr> */}
                                <tr>
                                  <td className="no-border">
                                    <Typography
                                      textAlign="right"
                                      // className={`td text-bold`}
                                      sx={{
                                        fontSize: "15px",
                                      }}
                                    >
                                      {poDetails
                                        ? poDetails.company_website
                                        : `https://kgbuildtech.com`}
                                    </Typography>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="no-border">
                                    <Typography
                                      textAlign="right"
                                      // className={`td text-bold`}
                                      sx={{
                                        fontSize: "15px",
                                      }}
                                    >
                                      {poDetails
                                        ? `GST NO: ${poDetails.gst_no}`
                                        : ``}
                                    </Typography>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <hr></hr>
                          <div>
                            <div style={styles.container}>
                              <div
                                style={{
                                  ...styles.section,
                                  flex: "1 1 calc(33.333% - 20px)",
                                }}
                              >
                                <Typography
                                  style={styles.bold}
                                  sx={{
                                    fontSize: "22px",
                                  }}
                                >
                                  Bill To :
                                </Typography>
                                <Typography
                                  style={styles.companyName}
                                  sx={{
                                    fontSize: "18px",
                                  }}
                                >
                                  {poDetails.vendor_name}
                                </Typography>
                                <Typography>
                                  {poDetails.vendor_mobile}
                                </Typography>

                                <Typography>
                                  {poDetails.vendor_street}
                                </Typography>
                                <Typography>{poDetails.vendor_city}</Typography>
                                {poDetails.vendor_state?.toLowerCase() !==
                                  "tamilnadu" && (
                                  <>
                                    <Typography>
                                      {poDetails.vendor_state}
                                    </Typography>
                                    <Typography> India,</Typography>
                                  </>
                                )}

                                <Typography>
                                  {poDetails.vendor_pincode}
                                </Typography>

                                <Typography>
                                  <span style={styles.bold}>GSTIN :</span>{" "}
                                  {poDetails.vendor_gst}
                                </Typography>
                              </div>

                              {/* <div
                            style={{
                              ...styles.section,
                              flex: "1 1 calc(33.333% - 20px)",
                            }}
                          >
                            <Typography
                              style={styles.bold}
                              sx={{
                                fontSize: "22px",
                              }}
                            >
                              Place of Supply :
                            </Typography>
                            <Typography
                              style={styles.companyName}
                              sx={{
                                fontSize: "18px",
                              }}
                            >
                              {projectDetails.name}
                            </Typography>
                            <Typography style={styles.bold}>
                              Address :
                            </Typography>
                            <Typography>
                              {projectDetails.project_address}
                            </Typography>
                            <Typography>{projectDetails.city}</Typography>

                            {projectDetails.state?.toLowerCase() !==
                              "tamilnadu" && (
                              <>
                                <Typography style={{ marginTop: 4 }}>
                                  {projectDetails.state}
                                </Typography>
                                <Typography style={{ marginTop: 4 }}>
                                  India,
                                </Typography>
                              </>
                            )}

                            <Typography>{projectDetails.pincode}</Typography>
                          </div> */}

                              <div
                                style={{
                                  ...styles.section,
                                  flex: "1 1 calc(33.333% - 20px)",
                                }}
                              >
                                <Typography
                                  style={styles.bold}
                                  sx={{
                                    fontSize: "22px",
                                  }}
                                >
                                  Place of Supply :
                                </Typography>

                                 {(!address || address.type === 1 || !address.address) ? (
                                   <>
                                    <Typography
                                      style={styles.companyName}
                                      sx={{
                                        fontSize: "18px",
                                      }}
                                    >
                                      {projectDetails?.name}
                                    </Typography>

                                    <Typography style={styles.bold}>
                                      Address :
                                    </Typography>

                                    <Typography>
                                      {projectDetails?.project_address}
                                    </Typography>

                                    <Typography>
                                      {projectDetails?.city}
                                    </Typography>

                                    {projectDetails?.state?.toLowerCase() !==
                                      "tamilnadu" && (
                                      <>
                                        <Typography style={{ marginTop: 4 }}>
                                          {poDetails?.address_type === 2
                                            ? poDetails.company_state
                                            : projectDetails?.state}
                                        </Typography>
                                        <Typography style={{ marginTop: 4 }}>
                                          India,
                                        </Typography>
                                      </>
                                    )}

                                    <Typography>
                                      {projectDetails?.pincode}
                                    </Typography>
                                  </>
                                ) : (
                                  <>
                                    <Typography>
                                      {address?.address
                                        ?.split(",")
                                        .map((line, index, arr) => (
                                          <Typography key={index}>
                                            {line.trim()}
                                            {index < arr.length - 1 ? "," : ""}
                                            <br />
                                          </Typography>
                                        ))}
                                    </Typography>
                                  </>
                                )}
                              </div>

                              <div
                                style={{
                                  ...styles.section,
                                  flex: "1 1 calc(33.333% - 20px)",
                                }}
                              >
                                <Typography style={{ marginTop: "6px" }}>
                                  <span style={{ fontWeight: "bold" }}>
                                    {poDetails.order_type == "1"
                                      ? "PO Order No:"
                                      : "WO Order No:"}
                                  </span>{" "}
                                  {poDetails.po_no}
                                </Typography>
                                <Typography style={{ marginTop: "6px" }}>
                                  <span style={{ fontWeight: "bold" }}>
                                    {poDetails.order_type == "1"
                                      ? "PO Date:"
                                      : "WO Date:"}
                                  </span>{" "}
                                  {moment(poDetails.po_date).format(
                                    "DD-MM-YYYY",
                                  )}
                                </Typography>

                                <Typography style={{ marginTop: "6px" }}>
                                  <span style={{ fontWeight: "bold" }}>
                                    Supplier Ref:
                                  </span>{" "}
                                  {poDetails.quotation_no}
                                </Typography>

                                <Typography style={{ marginTop: "6px" }}>
                                  <span style={{ fontWeight: "bold" }}>
                                    {poDetails.order_type == "1"
                                      ? "PO Classification:"
                                      : "WO Classification:"}{" "}
                                  </span>{" "}
                                  {get_purchase_classification(
                                    poDetails.purchase_classfication,
                                  )}
                                  {ClassificationData}
                                </Typography>

                                <Typography style={{ marginTop: "6px" }}>
                                  <span style={{ fontWeight: "bold" }}>
                                    Site Engineer :
                                  </span>{" "}
                                  {poDetails.site_eng_name}
                                </Typography>
                                <Typography style={{ marginTop: "6px" }}>
                                  <span style={{ fontWeight: "bold" }}>
                                    Contact :
                                  </span>{" "}
                                  {poDetails.site_eng_contact}
                                </Typography>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <Grid className="table_pdf" item xs={12} lg={12} md={12}>
                        <table className="po-content-2">
                          <thead>
                            <th>
                              <Typography sx={{ fontWeight: "bold" }}>
                                S.No
                              </Typography>
                            </th>
                            <th>
                              <Typography sx={{ fontWeight: "bold" }}>
                                Description of Goods{" "}
                              </Typography>
                            </th>
                            <th>
                              <Typography sx={{ fontWeight: "bold" }}>
                                Quantity
                              </Typography>
                            </th>
                            <th>
                              <Typography sx={{ fontWeight: "bold" }}>
                                Amount (₹)
                              </Typography>
                            </th>
                            <th>
                              <Typography sx={{ fontWeight: "bold" }}>
                                Discount
                              </Typography>
                            </th>
                            <th>
                              <Typography sx={{ fontWeight: "bold" }}>
                                GST{" "}
                              </Typography>
                            </th>
                            <th>
                              <Typography sx={{ fontWeight: "bold" }}>
                                Total Amount without GST
                              </Typography>
                            </th>
                          </thead>
                          <tbody className="pdf-tbl_body">
                            {paymentList.length > 0 ? (
                              paymentList.map((row, index) => (
                                <>
                                  <tr className="table_padding">
                                    <td className={`text-center`}>
                                      <Typography>{index + 1}</Typography>
                                    </td>
                                    <td className="po_leble">
                                      <Typography textAlign="right">
                                        {row.item_name}
                                      </Typography>
                                    </td>
                                    <td className="po_leble">
                                      <Typography textAlign="right">
                                        {twoDecimal(row.quantity)} {row.unit} (
                                        {row.unit_name})
                                      </Typography>
                                    </td>
                                    <td className="po_leble">
                                      <Typography textAlign="right">
                                        {twoDecimal(row.amount)}
                                      </Typography>
                                    </td>

                                    {/* Discount column */}
                                    <td className="po_leble">
                                      <Typography textAlign="right">
                                        {row.discount_type === "fixed"
                                          ? `Rs. ${twoDecimal(row.discount_value)}`
                                          : row.discount_type === "percentage"
                                            ? `${row.discount_value}%`
                                            : "—"}
                                      </Typography>
                                    </td>

                                    <td className="po_leble">
                                      <Typography textAlign="right">
                                        {row.gst}%
                                      </Typography>
                                    </td>

                                    <td className="po_leble">
                                      <Typography textAlign="right">
                                        {twoDecimal(
                                          row.discount_type === "fixed"
                                            ? row.amount * row.quantity -
                                                row.discount_value
                                            : row.discount_type === "percentage"
                                              ? row.amount *
                                                row.quantity *
                                                (1 - row.discount_value / 100)
                                              : row.amount * row.quantity,
                                        )}
                                      </Typography>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : (
                              <></>
                            )}
                          </tbody>
                          <tbody className="tbody_col">
                            <tr className="table_padding_40">
                              <td colSpan={5}>
                                <Typography
                                  fontWeight={`bold`}
                                  textAlign="right"
                                  style={{ paddingRight: "12px" }}
                                >
                                  Total amount
                                </Typography>
                              </td>
                              <td colSpan={2}>
                                <Typography textAlign="right">
                                  {twoDecimal(poDetails.total_without_gst)}
                                </Typography>
                              </td>
                            </tr>
                            <tr className="table_padding_40">
                              {poDetails.total_cgst == 0 &&
                              poDetails.total_sgst == 0 ? (
                                <>
                                  <td colSpan={5}>
                                    <Typography
                                      fontWeight={`bold`}
                                      textAlign="right"
                                      style={{ paddingRight: "12px" }}
                                    >
                                      IGST{" "}
                                    </Typography>
                                  </td>
                                  <td colSpan={2}>
                                    <Typography textAlign="right">
                                      {twoDecimal(poDetails.total_igst)}
                                    </Typography>
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td colSpan={5}>
                                    <Typography
                                      fontWeight={`bold`}
                                      textAlign="right"
                                      style={{ paddingRight: "12px" }}
                                    >
                                      CGST{" "}
                                    </Typography>
                                  </td>
                                  <td colSpan={2}>
                                    <Typography textAlign="right">
                                      {twoDecimal(poDetails.total_cgst)}
                                    </Typography>
                                  </td>
                                </>
                              )}
                            </tr>

                            {poDetails.total_sgst != 0 && (
                              <>
                                <tr className="table_padding_40">
                                  <td colSpan={5}>
                                    <Typography
                                      fontWeight={`bold`}
                                      textAlign="right"
                                      style={{ paddingRight: "12px" }}
                                    >
                                      SGST{" "}
                                    </Typography>
                                  </td>
                                  <td colSpan={2}>
                                    <Typography textAlign="right">
                                      {twoDecimal(poDetails.total_sgst)}
                                    </Typography>
                                  </td>
                                </tr>
                              </>
                            )}
                            <tr className="table_padding_40">
                              <td colSpan={4}>
                                <Typography
                                  fontWeight={`bold`}
                                  textAlign="right"
                                  style={{ paddingRight: "12px" }}
                                >
                                  Transport Charges
                                </Typography>
                              </td>
                              <td className="po_leble">
                                <Typography textAlign="center">
                                  GST {poDetails.transport_gst}%
                                </Typography>
                              </td>
                              <td colSpan={1}>
                                <Typography
                                  textAlign="right"
                                  style={{ paddingRight: "12px" }}
                                >
                                  {twoDecimal(poDetails.transport_amount || 0)}
                                </Typography>
                              </td>
                              <td colSpan={1}>
                                <Typography textAlign="right">
                                  {twoDecimal(
                                    poDetails.transport_charge || 0,
                                  )}{" "}
                                </Typography>
                              </td>
                            </tr>

                            <tr>
                              <td colSpan={5}>
                                <Typography
                                  sx={{ fontSize: "16px", fontWeight: "bold" }}
                                  textAlign="right"
                                  style={{ paddingRight: "12px" }}
                                >
                                  Total Payable Amount
                                </Typography>
                              </td>
                              <td colSpan={2}>
                                <Typography
                                  sx={{ fontSize: "16px", fontWeight: "bold" }}
                                  textAlign="right"
                                >
                                  {roundUpToInteger(poDetails.total_with_gst)}
                                </Typography>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        {/* Invoice terms and condition */}
                        <Grid
                          className="table_pdf"
                          item
                          xs={12}
                          lg={12}
                          md={12}
                        >
                          <table>
                            <thead>
                              <th>
                                <Typography sx={{ fontWeight: "bold" }}>
                                  {poDetails.order_type == "1"
                                    ? "PO Terms & Condition(s):"
                                    : "WO Terms & Condition(s):"}
                                </Typography>
                              </th>
                            </thead>
                            <tbody>
                              {/* items form */}
                              <tr className="table_padding">
                                <td className="po_leble">
                                  <Typography textAlign="center">
                                    {poDetails.terms ? (
                                      <div
                                        dangerouslySetInnerHTML={renderHTML(
                                          poDetails?.terms,
                                        )}
                                      />
                                    ) : (
                                      "-"
                                    )}
                                  </Typography>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </Grid>

                        {/* Amount in words 
                    <Grid className="table_pdf" item xs={12} lg={12} md={12}>
                      <table>
                        <thead>
                          <b>TOTAL PURCHASE ORDER VALUE (IN WORDS)</b>
                        </thead>
                        <tr>
                          <h5
                            style={{
                              marginTop: "10px",
                              marginBottom: "1rem",
                              fontWeight: "normal",
                            }}
                          >
                            {poDetails &&
                              poDetails.total_with_gst > 0 &&
                              `${handleNumberToWOrdCurrency(
                                poDetails.total_with_gst
                              )}`}
                          </h5>
                        </tr>
                      </table>
                    </Grid>*/}

                        {/* Bank Details Section */}

                        <Grid container spacing={2} sx={{ mt: 4 }}>
                          <Grid item xs={12}>
                            <Typography
                              sx={{ fontWeight: "bold", fontSize: "1.2rem" }}
                            >
                              Bank Details
                            </Typography>
                          </Grid>

                          <Grid item container xs={12} spacing={2}>
                            {/* Left Column */}
                            <Grid item xs={12} md={6}>
                              <Typography>
                                <span style={{ fontWeight: "bold" }}>
                                  Bank Name:
                                </span>{" "}
                                <span style={{ fontSize: "14px" }}>
                                  {poDetails.bank_name}
                                </span>
                              </Typography>
                              <Typography>
                                <span style={{ fontWeight: "bold" }}>
                                  Account Name:
                                </span>{" "}
                                <span style={{ fontSize: "14px" }}>
                                  {poDetails.account_name}
                                </span>
                              </Typography>
                              <Typography>
                                <span style={{ fontWeight: "bold" }}>
                                  Account Number:
                                </span>{" "}
                                <span style={{ fontSize: "14px" }}>
                                  {poDetails.account_no}
                                </span>
                              </Typography>
                            </Grid>

                            {/* Right Column */}
                            <Grid item xs={12} md={6}>
                              <Typography>
                                <span style={{ fontWeight: "bold" }}>
                                  Branch:
                                </span>{" "}
                                <span style={{ fontSize: "14px" }}>
                                  {poDetails.branch}
                                </span>
                              </Typography>
                              <Typography>
                                <span style={{ fontWeight: "bold" }}>
                                  IFSC Code:
                                </span>{" "}
                                <span style={{ fontSize: "14px" }}>
                                  {poDetails.ifsc_code}
                                </span>
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Typography
                          sx={{
                            fontSize: "20px",
                            mt: 5,
                            fontWeight: 700,
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>Prepared By</span>
                          <span>Verified By</span>
                          <span>Approved By QS</span>
                          <span>Approved By</span>
                          <span>Contractor/Vendor Signature</span>
                        </Typography>
                      </Grid>
                    </table>
                  </Grid>
                </Grid>
              </div>

              {/* Lower Buttons */}
              <div className="empty-space-20"></div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {poDetails.status == 91 && (
                  <div
                    style={{
                      position: "absolute",
                      right: "100px",
                      paddingBottom: "2rem",
                      marginTop: "3rem",
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#2F58CD",
                        marginRight: "10px",
                        color: "white",
                      }}
                      className="button"
                      onClick={() => setPOStatus(91)}
                    >
                      Approve
                    </Button>
                    <Button
                      style={{ backgroundColor: "#2F58CD", color: "white" }}
                      className="button"
                      onClick={() => setPOStatus(92)}
                    >
                      Deny
                    </Button>
                  </div>
                )}
              </div>
            </Grid>

            <Grid item xs={11}>
              <Box display={`flex`} justifyContent={`flex-end`} mr={2}>
                {/* <PurchaseOrderPDF
              poDetails={poDetails}
              projectDetails={projectDetails}
              paymentList={paymentList}
              companyLogo={companyLogo}
              classificationData={ClassificationData}
            />
             */}
                <PDFDownloadLink
                  document={
                    <PdfDocument
                      poDetails={poDetails}
                      projectDetails={projectDetails}
                      paymentList={paymentList}
                      companyLogo={companyLogo}
                      classificationData={ClassificationData}
                    />
                  }
                  fileName={`${extractedNumber} ${poDetails.vendor_name} ${moment(
                    poDetails.po_date,
                  ).format(
                    "DD-MM-YYYY",
                  )}@${poDetails.project_name}.pdf`.replace(/\s+/g, " ")}
                  style={{
                    textDecoration: "none",
                    padding: "10px 20px",
                    color: "#fff",
                    backgroundColor: "#2F58CD",
                    borderRadius: 4,
                    fontWeight: "bold",
                  }}
                >
                  {({ loading }) =>
                    loading ? "Generating PDF..." : "Generate PDF"
                  }
                </PDFDownloadLink>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
}
export default PurchaseOrderView;
